import {appConfig} from '../config'
import {FALLBACK_DEFAULT_VERTICALS_WITH_ADDITIONAL_OPTIONS} from './consts'

export const experiments = {
  isBusinessToggleVisible: getBooleanConfigValue(
    appConfig.experiments3?.delivery_frontend_order_business_toggle_visibility?.enabled,
  ),
  shouldShowPromoBanner: getBooleanConfigValue(appConfig.experiments3?.delivery_frontend_order_promo_banner?.enabled),
  bduiDebounceDuration: getNumberConfigValue(appConfig.experiments3?.delivery_order_bdui_debounce_duration?.value),
  verticalsWithAdditionalOptions: getVerticalsWithAdditionalOptions(),
}

function getNumberConfigValue(configValue?: unknown): number | undefined {
  /** явно типизируем конфиги, в которых ожидаем число */
  return typeof configValue === 'number' ? configValue : undefined
}

function getBooleanConfigValue(configValue?: unknown): boolean {
  /** явно приводим значение конфига к true или false, т.к. в конфиге может прийти произвольный JSON */
  return configValue === true
}

function getVerticalsWithAdditionalOptions(): string[] {
  const verticals = appConfig.experiments3?.delivery_verticals_enabled_additional_options?.enabled_verticals
  return verticals ?? FALLBACK_DEFAULT_VERTICALS_WITH_ADDITIONAL_OPTIONS
}
